import { z } from 'zod/v4'
import { useMesaDynamicConfig } from '@/src/services/Statsig/useMesaDynamicConfig'

export const PointOptionSchema = z.object({
  mesaPoints: z.number().int().positive(),
  credits: z.number().int().positive(),
})

export const OmniPointsTransferSchema = z.object({
  pointsOptions: z.array(PointOptionSchema),
  registrationLink: z.string(),
})

export type OmniPointsTransfer = z.infer<typeof OmniPointsTransferSchema>
export type PointOption = z.infer<typeof PointOptionSchema>

export function useOmniPointsTransferDynamicConfig() {
  return useMesaDynamicConfig('omni_points_transfer')
}
